exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.new-service {\n  /*.language-error{\n    @include font-size(14);\n    margin-top: 15px;\n    color: red;\n  }*/ }\n  .new-service .uk-button {\n    font-size: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/services/new-services/new-service.component.scss
// module id = ../../../../../src-admin/app/components/services/new-services/new-service.component.scss
// module chunks = main